import { inventoryCategoryNet } from './category';
import { inventoryGeneralNet } from './general';
import { inventoryOperationNet } from './operation';

export class InventoryNet {
  static general = inventoryGeneralNet;
  static category = inventoryCategoryNet;
  static operation = inventoryOperationNet;
}
